import { render } from "./BannerDetail.vue?vue&type=template&id=46f176f8&scoped=true"
import script from "./BannerDetail.vue?vue&type=script&lang=js"
export * from "./BannerDetail.vue?vue&type=script&lang=js"

import "./BannerDetail.vue?vue&type=style&index=0&id=46f176f8&lang=less&scoped=true"

import exportComponent from "/Users/sun/Desktop/code/antpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f176f8"]])

export default __exports__